<ng-container *ngIf="images; else loading">
  <div *ngIf="!dev()" id="images">
    <div class="image-cell" *ngFor="let image of images; let i = index">
      <img [src]="image.url" (click)="openGallery(i)" />
      <button
        *ngIf="dcmKeys && dcmKeys[i]"
        type="button"
        class="btn btn-sm btn-link dicom-header-link"
        (click)="onViewHeader(dcmKeys[i])"
      >
        DICOM header
      </button>
    </div>
  </div>
  <ngx-image-gallery
    [images]="images"
    [conf]="conf"
    (onOpen)="galleryOpened($event)"
    (onClose)="galleryClosed()"
    (onImageClicked)="galleryImageClicked($event)"
    (onImageChange)="galleryImageChanged($event)"
    (onDelete)="deleteImage($event)"
  ></ngx-image-gallery>
</ng-container>

<ng-template #loading>loading images...</ng-template>

<app-dicom-header-modal
  [(open)]="headerModalOpen"
  [tags]="headerTags"
  [loading]="headerLoading"
  title="DICOM Header"
  [subtitle]="headerSubtitle"
></app-dicom-header-modal>
